import { forwardRef } from 'react';

import { IconProps } from '.';

export const DeleteIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M15.7775 4.69751C15.9176 4.55742 15.9974 4.36815 16 4.17004C15.9977 3.97695 15.922 3.79197 15.7883 3.65267C15.6546 3.51337 15.4728 3.43019 15.28 3.42004H12.05C12.05 3.22113 11.971 3.03037 11.8303 2.88971C11.6897 2.74906 11.4989 2.67004 11.3 2.67004H8.75C8.55109 2.67004 8.36032 2.74906 8.21967 2.88971C8.07902 3.03037 8 3.22113 8 3.42004H4.75C4.55109 3.42004 4.36032 3.49906 4.21967 3.63971C4.07902 3.78037 4 3.97113 4 4.17004C4 4.36896 4.07902 4.55972 4.21967 4.70037C4.36032 4.84103 4.55109 4.92004 4.75 4.92004H15.25C15.4481 4.91745 15.6374 4.8376 15.7775 4.69751Z"
        fill="currentColor"
      />
      <path
        d="M15.26 14.33V6.67004H13.76V14.33C13.76 14.5661 13.6662 14.7925 13.4993 14.9594C13.3324 15.1263 13.106 15.22 12.87 15.22H7.13C6.89396 15.22 6.66758 15.1263 6.50067 14.9594C6.33377 14.7925 6.24 14.5661 6.24 14.33V6.67004H4.74V14.33C4.74 14.9639 4.9918 15.5718 5.44001 16.02C5.88822 16.4682 6.49613 16.72 7.13 16.72H12.87C13.5039 16.72 14.1118 16.4682 14.56 16.02C15.0082 15.5718 15.26 14.9639 15.26 14.33Z"
        fill="currentColor"
      />
      <path
        d="M8.49 6.67004C8.90421 6.67004 9.24 7.00583 9.24 7.42004V12.47C9.24 12.8843 8.90421 13.22 8.49 13.22C8.07578 13.22 7.74 12.8843 7.74 12.47V7.42004C7.74 7.00583 8.07578 6.67004 8.49 6.67004Z"
        fill="currentColor"
      />
      <path
        d="M12.24 7.42004C12.24 7.00583 11.9042 6.67004 11.49 6.67004C11.0758 6.67004 10.74 7.00583 10.74 7.42004V12.47C10.74 12.8843 11.0758 13.22 11.49 13.22C11.9042 13.22 12.24 12.8843 12.24 12.47V7.42004Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default DeleteIcon;
